<template>
  <div class="typeaheadComponent">

    <div class="control has-icons-right">
      <!-- the input field -->
      <input type="text"
        v-bind:name="fieldName"
        v-bind:id="fieldName"
        class="input" 
        v-bind:placeholder="placeholder"
        autocomplete="off"
        v-model="query"
        @keydown.down="down"
        @keydown.up="up"
        @keydown.enter="hit"
        @keydown.esc="resetInput"
        @blur="resetInput"
        @input="autoComplete"/>

      <span class="icon is-small is-right">
        <!-- optional indicators -->
        <i class="fa fa-spinner fa-spin" v-if="loading"></i>
        <template v-else>
          <i class="fa fa-search"></i>
        </template>
      </span>
    </div>


    <!-- the list -->
    <ul class="typeaheadResults" v-show="hasItems">
      <li v-for="(item, $item) in items" :class="activeClass($item)" @mousedown="hit" @mousemove="setActive($item)">
        <span v-text="item.name"></span>
      </li>
    </ul>
  </div>
</template>

<script>
import VueTypeahead from 'vue-typeahead'

var searchTimer;

export default {
  extends: VueTypeahead,

  props: {
    source: {
      type: [String, Array],
      required: true
    },
    grouptype: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      
      query: '',
      isHit: false,
      name: '',

      // The source url
      // (required)
      src: this.source + this.grouptype,

      // The data that would be sent by request
      // (optional)
      data: {},

      // Limit the number of items which is shown at the list
      // (optional)
      limit: 10,

      // The minimum character length needed before triggering
      // (optional)
      minChars: 1,

      // Highlight the first item in the list
      // (optional)
      selectFirst: false

      // Override the default value (`q`) of query parameter name
      // Use a falsy value for RESTful query
      // (optional)
      //queryParamName: 'search'
    }
  },

  methods: {
    // The callback function which is triggered when the user hits on an item
    // (required)
    onHit (item) {
      this.isHit = true;
      this.query = item.name;
      if(item.error) {
        this.query = '';  
      } else {
        this.query = item.name;
      }
      this.emitValues(item.name);
      this.name = item.name;
      this.loading = false;
      this.items = [];   
    },

    // The callback function which is triggered when the response data are received
    // (optional)
    prepareResponseData (data) {
      // data = ...
      return data
    },

    autoComplete: function() {

      if(this.query.length > 0) {
        clearTimeout(searchTimer);
        searchTimer = setTimeout( this.update, 300 );
      } else {
        // if input blanked out send empty string to search all items.
        this.emitValues('');
      }

    },

    resetInput: function() {

      if(!this.isHit) {
        //alert("not hit");
        this.query = '';  
        this.emitValues('');
        this.reset
      } else {
        //alert("hit");
        //this.query = '';  
        //this.$emit('recipient', '');
      }

      this.isHit = false
      this.items = []
      this.loading = false
    },

    emitValues: function(value) {
      this.$emit('recipient', value);
    },

    clearQuery: function() {
      this.query = 'clear'
      alert('clear')
    }



  }
}
</script>

<style>
  .typeaheadComponent .typeaheadResults {
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 1px 1px 5px #aaaaaa;
  }
  .typeaheadComponent li {
    padding: .25em;
    border-bottom: 1px solid #eee;
  }
  .typeaheadComponent li.active {
    background: #222;
    color: #fff;
  }
</style>


// WEBPACK FOOTER //
// Modules/Register/Resources/assets/js/components/Typeahead-Recipients.vue